import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'uiSnippet',
    standalone: false
})
export class SnippetPipe implements PipeTransform {
  transform(value: any, args: string): any {
    if (!!value && !!args && Object.keys(value).length > 0) {
      const startIndex = args.indexOf('(');
      const endIndex = args.indexOf(')');
      const func = args.slice(startIndex + 1, endIndex);
      const [, item, suffix] = func.split('.');

      if (!(item in value)) {
        return null;
      }

      if (suffix) {
        return value[item][suffix];
      }

      return value[item];
    }

    return null;
  }

}
